import(/* webpackMode: "eager" */ "/codebuild/output/src187247037/src/apps/webapp/src/app/global-error.tsx");
